
<template>
  <div class="recharge-header">
    <img :src="userInfo.pic" alt="">
    <span>ID: {{userInfo.userId}}</span>
  </div>
</template>

<script>
export default {
  props: ['userInfo']
}
</script>

<style lang="scss">
  @charset "UTF-8";
  @import "../../style/main";

  .recharge-header {
    background-color: #fff;
    padding: rem(40) rem(30);
    display: flex;
    align-items: center;
    margin-bottom: rem(15);
    > img {
      width: rem(90);
      height: rem(90);
      border-radius: 100%;
      margin-right: rem(20);
    }
    span {
      color: #333;
      font: {
        size: rem(42);
        weight: bold;
      }
    }
  }
</style>
